import { Input } from "@/shared/components/shadcn/Input";
import { Select } from "@/shared/components/shadcn/Select";
import { FormField } from "@/shared/components/ui/FormField";
import { TimezoneSelect } from "./TimezoneSelect";

const industries = [
  "Make-up artists", "Nails", "Hair salon", "Barbershop", "Massage therapy",
  "Spa services", "Tattoo & Piercing", "Personal training", "Yoga & Pilates",
  "Esthetics & Skincare", "Other",
];
const currencies = ["USD", "EUR", "GBP", "JPY", "AUD", "CAD"];

interface BusinessFieldsProps {
  value: { name: string; industry: string; timezone: string; currency: string };
  onChange: (value: BusinessFieldsProps["value"]) => void;
}

export function BusinessFields({ value, onChange }: BusinessFieldsProps) {
  return (
    <>
      <FormField id="industry" label="Industry">
        <Select required value={value.industry} onChange={(event) => onChange({ ...value, industry: event.target.value })}>
          <option value="">Select an industry</option>
          {value.industry && !industries.includes(value.industry) && <option value={value.industry}>{value.industry}</option>}
          {industries.map((industry) => <option key={industry} value={industry}>{industry}</option>)}
        </Select>
      </FormField>
      <FormField id="business-name" label="Business name">
        <Input required pattern=".*\S.*" title="Enter a business name, not just spaces." autoComplete="organization" value={value.name} onChange={(event) => onChange({ ...value, name: event.target.value })} />
      </FormField>
      <FormField id="timezone" label="Timezone" description="Weekly working hours and appointment displays use this timezone, including daylight-saving changes. Changing it does not move existing appointments. Calendar events keep their saved timezone.">
        <TimezoneSelect required value={value.timezone} onChange={(event) => onChange({ ...value, timezone: event.target.value })} />
      </FormField>
      <FormField id="currency" label="Currency">
        <Select required value={value.currency} onChange={(event) => onChange({ ...value, currency: event.target.value })}>
          {!currencies.includes(value.currency) && <option value={value.currency}>{value.currency}</option>}
          {currencies.map((currency) => <option key={currency} value={currency}>{currency}</option>)}
        </Select>
      </FormField>
    </>
  );
}
